module.exports = __webpack_public_path__ + "static/media/Sol-amarelo.54fe0675.svg";